export default __webpack_public_path__ + "static/media/volumeIcon.27243d0c.svg";